export const ANIMAL = [
  {
    _id: '6847ab0f30886fb75cf71b43',
    component_content_id: '63806cb240b4a5aea422f0a5',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    link: null,
    currency: 'thb',
    sequence: '1',
    image_desktop_path: {
      'en-US': 'demo/games/animal/image-1-en.png',
      'th-TH': 'demo/games/animal/image-1-th.png',
      'zh-CN': 'demo/games/animal/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/animal/image-1-en-mobile.png',
      'th-TH': 'demo/games/animal/image-1-th-mobile.png',
      'zh-CN': 'demo/games/animal/image-1-ch-mobile.png'
    },
    __v: 0,
    item_id: '6847ab0f30886fb75cf71b43'
  },
  {
    _id: '6847ab0f30886fb75cf71b41',
    component_content_id: '63806cb240b4a5aea422f0a5',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    link: null,
    currency: 'thb',
    sequence: '1',
    image_desktop_path: {
      'en-US': 'demo/games/animal/image-2-en.png',
      'th-TH': 'demo/games/animal/image-2-th.png',
      'zh-CN': 'demo/games/animal/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/animal/image-2-en-mobile.png',
      'th-TH': 'demo/games/animal/image-2-th-mobile.png',
      'zh-CN': 'demo/games/animal/image-2-ch-mobile.png'
    },
    __v: 0,
    item_id: '6847ab0f30886fb75cf71b41'
  },
  {
    _id: '6847ab0f30886fb75cf71b44',
    component_content_id: '63806cb240b4a5aea422f0a5',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    link: null,
    currency: 'thb',
    sequence: '1',
    image_desktop_path: {
      'en-US': 'demo/games/animal/image-3-en.png',
      'th-TH': 'demo/games/animal/image-3-th.png',
      'zh-CN': 'demo/games/animal/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/animal/image-3-en-mobile.png',
      'th-TH': 'demo/games/animal/image-3-th-mobile.png',
      'zh-CN': 'demo/games/animal/image-3-ch-mobile.png'
    },
    __v: 0,
    item_id: '6847ab0f30886fb75cf71b43'
  },
  {
    _id: '6847ab0f30886fb75cf71b46',
    component_content_id: '63806cb240b4a5aea422f0a5',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    link: null,
    currency: 'thb',
    sequence: '1',
    image_desktop_path: {
      'en-US': 'demo/games/animal/image-4-en.png',
      'th-TH': 'demo/games/animal/image-4-th.png',
      'zh-CN': 'demo/games/animal/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/animal/image-4-en-mobile.png',
      'th-TH': 'demo/games/animal/image-4-th-mobile.png',
      'zh-CN': 'demo/games/animal/image-4-ch-mobile.png'
    },
    __v: 0,
    item_id: '6847ab0f30886fb75cf71b43'
  },
  {
    _id: '6847ab0f30886fb75cf71b11',
    component_content_id: '63806cb240b4a5aea422f0a5',
    title: {},
    description: {},
    is_visible: true,
    is_active: true,
    link_type: 1,
    link: null,
    currency: 'thb',
    sequence: '1',
    image_desktop_path: {
      'en-US': 'demo/games/animal/image-5-en.png',
      'th-TH': 'demo/games/animal/image-5-th.png',
      'zh-CN': 'demo/games/animal/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/animal/image-5-en-mobile.png',
      'th-TH': 'demo/games/animal/image-5-th-mobile.png',
      'zh-CN': 'demo/games/animal/image-5-ch-mobile.png'
    },
    __v: 0,
    item_id: '6847ab0f30886fb75cf71b43'
  }
]
